import { useState, useEffect } from 'react';
import CourseDetailService from '../services/coursesApi/CourseDetailService';

const useCourseDetails = (courseId, batchId) => {
  const [courseDetails, setCourseDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCourseDetails = async () => {
      if (!courseId || !batchId) {
        setError("Missing course or batch ID");
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      try {
        // For production, use the real API call
        // const response = await CourseDetailService.getCourseDetails(courseId, batchId);
        
        // For development, use the mock data
        const response = await CourseDetailService.getMockCourseDetails(courseId, batchId);
        
        setCourseDetails(response.data);
        setError(null);
      } catch (err) {
        console.error("Error fetching course details:", err);
        setError("Failed to load course details");
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchCourseDetails();
  }, [courseId, batchId]);

  return { courseDetails, isLoading, error };
};

export default useCourseDetails;